module.exports = __webpack_public_path__ + "img/collection-weddingRingsMulticolor.07438ef.webp";